import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatLabel } from '@repo/locale-client';
import { getLabels } from '../labels';
import OffScreenIndicatorSvg from './svgs/OffScreenIndicatorSvg';
const formatDistance = (meters) => meters < 1000 ? `${Math.round(meters)} m` : `${(meters / 1000).toFixed(1)} km`;
export default function OffScreenIndicator({ testId, marker, leftPercentage, topPercentage, angleDegree, distanceMeters, onClick, }) {
    const handleClick = () => onClick(marker);
    const distanceLabel = formatDistance(distanceMeters);
    const ariaLabel = formatLabel(getLabels().off_screen_indicator.aria_label, { distance: distanceLabel });
    const textRotateDegree = angleDegree < 0 ? 90 : -90;
    return (_jsx("button", { type: "button", "aria-label": ariaLabel, onClick: handleClick, "data-testid": testId, className: "pointer-events-auto absolute cursor-pointer drop-shadow-lg", style: {
            left: `${leftPercentage}%`,
            top: `${topPercentage}%`,
            transform: `translate(-50%, -50%) rotate(${angleDegree}deg)`,
        }, children: _jsxs("div", { className: "relative", children: [_jsx(OffScreenIndicatorSvg, {}), _jsx("span", { className: "text-brand font-base absolute left-1/2 -mt-1 text-sm whitespace-nowrap", style: {
                        top: '67.5%',
                        transform: `translate(-50%, -50%) rotate(${textRotateDegree}deg)`,
                    }, children: distanceLabel })] }) }));
}
